import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseComponent } from '../../shared/components/base-component';
import { ApplicationService } from '../../shared/services/application/application.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { CatalogService } from '../../shared/services/catalogs/catalog.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { FindSolicitationsService } from '../../shared/services/solicitations/find-solicitations.service';
import { NavigationService } from '../../shared/services/navigation/navigation-service.service';

@Component({
  selector: 'app-solicitation-search',
  templateUrl: './solicitation-search.component.html',
  styleUrls: ['./solicitation-search.component.scss']
})
export class SolicitationSearchComponent extends BaseComponent implements OnInit {

  /**
     * Almacena los datos recolectados en el formulario principal
     */
  form: FormGroup = this.fb.group({
    search: this.fb.group({})
  });

  /**
   * Contiene los textos y etiquetas
   */
  CONTENT_BOUNDS: any[] | any;

  constructor(
    private readonly cps: CopyService,
    private readonly fb: FormBuilder,
    private readonly catalog: CatalogService,
    private readonly find: FindSolicitationsService,
    private readonly link: LinkupService,
    private readonly app: ApplicationService,
    private readonly navigator: NavigationService
    ) { 
      super(app, link,"solicitation-search")
    }

  ngOnInit(): void {
    this.loadStaticValues().finally(()=>{
      super.onLoad();      
    });
  }

  /**
     * Permite la carga de textos y listas estaticas
     */
   async loadStaticValues() {
    this.navigator.startFlow("solicitationSearch");  
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy("solicitation-search");
}

  /**
     *  Controla el evento de salida principal
     * @param $event
     */
  onCloseEvent($event: any) {
    console.log('close event', $event);
  }

  /**
     * Permite consultar las solicitudes
     * @param $event
     */
   async findRequest($event: any) {

   }

   /**
     * Permite obtener la instancia del formulario para la consulta de solicitudes
     */
    get searchForm(): FormGroup {
      return this.form.get('search') as FormGroup;
  }
}

